import { render, staticRenderFns } from "./StatusBatch.vue?vue&type=template&id=4f172713&scoped=true&"
import script from "./StatusBatch.vue?vue&type=script&lang=ts&"
export * from "./StatusBatch.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f172713",
  null
  
)

export default component.exports